import { render, staticRenderFns } from "./project-view.vue?vue&type=template&id=03b72f1a&"
import script from "./project-view.vue?vue&type=script&lang=js&"
export * from "./project-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports